import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import logo from '../../../../assets/images/logo.png';
import Loader from "../../Common/Loader.jsx";
import Swal from "sweetalert2";

import {
  forgotPasswordAction,
  clearForgotPasswordState,
} from "../../../../store/actions/AppForgetPasswordAction.js";

const AppForgetPassword = () => {
  const [email, setEmail] = useState("");
  const dispatch = useDispatch();

  const { loading } = useSelector((state) => state.forgotPassword);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const isValidEmail = (email) => {
    const emailRegex = /^\S+@\S+\.\S+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Email validation
    if (!email) {
      Swal.fire({
        icon: "warning",
        title: "Email Required",
        text: "Please enter your email address.",
      });
      return;
    }

    if (!isValidEmail(email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address.",
      });
      return;
    }

    try {
      await dispatch(forgotPasswordAction(email));

      Swal.fire({
        icon: "success",
        title: "Reset Link Sent",
        text: "Please check your email for the reset link.",
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Request Failed",
        text: err.message || "Failed to send reset link. Please try again.",
      });
    }
  };

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <div style={containerStyle}>
      <div className="col-xl-4 col-lg-6 col-md-8 col-sm-10">
        <div className="card">
          <div className="card-body">
            <div className="text-center mb-4">
              <img src={logo} alt="Logo" className="logo ms-1" style={{ maxWidth: "150px" }} />
            </div>
            <h4 className="card-title text-center">Forgot Password?</h4>

            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={email}
                  onChange={handleEmailChange}
                  required
                />
              </div>
              <Button variant="primary" type="submit" className="w-100">
                Reset Password
              </Button>
            </form>

            <div className="text-center mt-3">
              <Link to="/login" className="btn btn-link">
                Back to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppForgetPassword;
